import * as React from 'react';
import { TextInputWithFloatingLabelContext } from './text-input.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const TextInputWithFloatingLabel = renderWithRef('TextInputWithFloatingLabel', null, (props, ref)=>{
    const { children  } = props;
    const classes = [
        'swan-vanilla-ignore',
        'swan-input-with-floating-label'
    ];
    const [inputId, setInputId] = React.useState();
    const [inputElem, setInputElem] = React.useState();
    return /*#__PURE__*/ React.createElement(TextInputWithFloatingLabelContext.Provider, {
        value: {
            inputId,
            setInputId,
            inputElem: inputElem,
            setInputElem: setInputElem
        }
    }, /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        props: props,
        classNames: classes
    }, children));
});

export { TextInputWithFloatingLabel };
